module.exports = __webpack_public_path__ + "media/images/icons/outlined/table-af90ab31f0addc7c0077ed47b3c281eb.svg";